// Turns sign-in errors into plain sentences.
export function authMessage(e: unknown): string {
  const m = String((e as { message?: string })?.message ?? e ?? '').toLowerCase();
  if (/rate limit|too many|security purposes/.test(m)) return 'Too many tries. Wait a minute, then try again.';
  if (/expired|invalid|otp/.test(m)) return 'That code didn’t work. It may have expired: ask for a new one.';
  if (/network|fetch|failed to fetch/.test(m)) return 'Can’t reach the server. Check your connection and try again.';
  if (/email/.test(m) && /valid/.test(m)) return 'Enter a valid email address.';
  return 'Sign-in didn’t work. Please try again.';
}
